<template>
  <div>
    <ConfirmationDialog2 ref="confirmationDialog" />
    <slot :submit="submit" :loading="loading" />
    <ExecutionResultsDialog @close="$emit('reload')" ref="executionResultsDialog">
      <template #title="{ isError }">
        <span v-if="isError">
          <v-icon class="mr-1" large color="error">error</v-icon>
          Failed to ingest the file
        </span>
        <span v-else>
          <v-icon class="mr-1" large color="success">check_circle</v-icon>
          Successfully ingested file
        </span>
      </template>
      <template #actions="{ FileResults }">
        <ul v-if="FileResults && FileResults.length == 1">
          <li class="pb-2">
            <router-link :to="{ name: 'dataset', params: { id: FileResults[0].FileId } }" target="_blank">Review the
              file</router-link> and its contents for any formatting mistakes. Reupload the file if any changes were
            made.
          </li>
          <li class="pb-2" v-if="isTenantAdmin">Customize the ingestion service configurations to better suit your file
            format.</li>
          <li class="pb-2" v-if="isTenantAdmin">
            <router-link :to="{ name: 'dataset', params: { id: FileResults[0].FileId } }" target="_blank">Manually set the
              file type</router-link> by editing the file.
          </li>
          <li class="pb-2">Contact your administrator or Hatfield if you require assistance.</li>
        </ul>
        <ul v-if="FileResults && FileResults.length > 1">
          <li class="pb-2">
            Review the files and their contents for any formatting mistakes.
          </li>
          <li class="pb-2" v-if="isTenantAdmin">Customize the ingestion service configurations to better suit your file
            formats.</li>
          <li class="pb-2" v-if="isTenantAdmin">
            Manually set the file types by editing the files directly.
          </li>
          <li class="pb-2">Contact your administrator or Hatfield if you require assistance.</li>
        </ul>
      </template>
      <template #next="{ FileResults }">
        <PrimaryBtn v-if="FileResults.length == 1" icon="event_note" color="primary"
          :to="{ name: 'allimports', query: { search: FileResults[0].ReingestionId } }">View ingestion summary
        </PrimaryBtn>
        <PrimaryBtn v-else-if="FileResults.length > 1" icon="event_note" color="primary"
          @click.prevent="goToImport(FileResults[0])">View ingestion summary</PrimaryBtn>
        <PrimaryBtn v-if="FileResults.length == 1 && FileResults[0].ServiceName != 'A125 Ingestion Service'"
          icon="pending_actions" color="primary"
          :to="{ name: 'reviewingestionresults', params: { executionId: FileResults[0].ReingestionId } }">Review
          ingestion</PrimaryBtn>
      </template>
    </ExecutionResultsDialog>
  </div>
</template>

<script>
import {
  createNamespacedHelpers,
} from 'vuex'


import { reingestConfirmParams } from '@/helpers/datasets/ingestions'

const ingestions = createNamespacedHelpers('ingestions')
const auth = createNamespacedHelpers('authenticate')
const imports = createNamespacedHelpers('imports')

export default {
  data: () => ({
    loading: false,
  }),
  computed: {
    ...auth.mapGetters(['isTenantAdmin']),
    ...imports.mapActions(['fetchImportByExecutionId']),
  },
  watch: {
    loading: {
      deep: true,
      handler(val) {
        this.$emit('loading', val)
      },
    },
  },
  methods: {
    ...ingestions.mapActions(['ingestFiles']),

    async submit(rdrFileId) {
      let confirmed = await this.$refs.confirmationDialog.confirm(reingestConfirmParams)
      if (!confirmed) return

      this.loading = true
      try {
        let result = await this.ingestFiles({
          rdrFileId,
        })

        this.$refs.executionResultsDialog.show(result)
      } catch (error) {
        this.$refs.executionResultsDialog.show(error)
      } finally {
        this.loading = false
        this.$emit('reload')
      }
    },
    async goToImport(fileResult) {
      if (fileResult.ServiceName != 'A125') {
        this.$router.push({
          name: 'allimports',
        })
      } else {
        let importResult = await this.fetchImportByExecutionId({
          executionId: fileResult.ReingestionId,
        })
        if (importResult != null) {
          this.$router.push({
            name: 'import',
            params: { importId: importResult.Id }, // Optional query parameters
          })

        } else {
          this.$router.push({
            name: 'allimports',
          })
        }

      }
    },
  },
}
</script>